import { TRENDING_AND_SEASONAL_OFFERS_VIEW } from './types';

export const triggerTrendingAndSeasonalOffersIsViewed = (offer, contentGroupId) => ({
  type: TRENDING_AND_SEASONAL_OFFERS_VIEW,
  offer,
  contentGroupId,
});
